// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r5qDo","field":"styles_field__35W8V","fieldCol":"styles_fieldCol__2L9uu","diffCol":"styles_diffCol__2GsyG","diff":"styles_diff__uY4gq"};